import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { TosterService } from '../../../services/toster.service';
import { ProfileService } from '../../../services/profile.service';
import { FormsModule } from '@angular/forms';
import { GooglePlacesAutocompleteDirective } from '../../../directives/google-places-autocomplete.directive';
import { CommonModule } from '@angular/common';
interface UploadedFiles {
  'file-upload-1': File | null;
  'file-upload-2': File | null;
  'file-upload-3': File | null;
  'file-upload-4': File | null;
}
@Component({
  selector: 'app-profile-verify',
  imports: [FormsModule,CommonModule],
  templateUrl: './profile-verify.component.html',
  styleUrl: './profile-verify.component.scss'
})
export class ProfileVerifyComponent implements OnInit {
registered_address: string = '';
requiredDocuments: any[] = [];
countryId: string = '';
constructor(private router: Router,private authService:AuthService,private tosterService:TosterService,private profileService:ProfileService) {}
ngOnInit(): void {
  this.getDocumets();
}
getDocumets() {
  this.profileService.getDocumentsList().subscribe({
    next: (res: any) => {
      if (res.status === true) {
        if(res.data.account_status=='under_verification'){
          console.log("account status under verification",res.data.account_status);
                      localStorage.setItem('verified', res.data.account_status);

          this.router.navigate(['/syncinns-pms/dashboard'])
        }
        this.requiredDocuments = res.data.required_documents.map((doc: any) => ({
  ...doc,
}));
        this.countryId = res.data.country;
      }
    },
    error: (errorResponse: any) => {
      this.tosterService.showError(errorResponse.error.message);
    },
  });
}
onCloseUploadDocs() {
      localStorage.setItem('verified', 'true')
  this.router.navigate(['/syncinns-pms/dashboard']);
}
  logout() {
    this.authService.logout();
  }
  
// Object to store selected files
  uploadedFiles: UploadedFiles = {
    'file-upload-1': null, 
    'file-upload-2': null, // Aadhar back
    'file-upload-3': null, // Passport
    'file-upload-4': null, // License
  };

  submitted: boolean = false;
  uploading: boolean = false;
  uploadProgress: number = 0; 
  onPlaceSelected(place: any) {
    if (place && place.formatted_address) {
      // Update the address field with the formatted address
      this.registered_address=place.name + ', ' + place.formatted_address;
      console.log('Selected place:', place);
      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        console.log('Location coordinates:', { lat, lng });
      }
    }
  }
onFileSelected(event: Event, docId: string): void {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];

  if (file) {
    // Allowed types
    const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes

    if (!allowedTypes.includes(file.type)) {
      this.tosterService.showError('Only PDF and image files (jpg, jpeg, png) are allowed.');
      input.value = ''; // reset input
      return;
    }

    if (file.size > maxSize) {
      this.tosterService.showError('File size should not exceed 5 MB.');
      input.value = ''; // reset input
      return;
    }

    const doc = this.requiredDocuments.find(d => d.doc_id === docId);
    if (doc) {
      doc.selectedFileName = file.name; // store selected file name
      this.uploadDocument(docId, file); // upload as before
    }
  }
}


uploadDocument(docId: string, file: File): void {
  const doc = this.requiredDocuments.find(d => d.doc_id === docId);
  if (!doc) return;

  const formData = new FormData();
  formData.append('country_id', this.countryId);
  formData.append('doc_id', doc.doc_id);
  formData.append('document_name', doc.doc_name);
  formData.append('document', file);

  this.profileService.uploadDocuments(formData).subscribe({
    next: (res) => {
      this.tosterService.showSuccess(`${doc.doc_name} uploaded successfully.`);
      this.profileService.invalidateDocumentsListCache();
      this.getDocumets(); // Refresh list
    },
    error: (err) => {
      this.tosterService.showError(`Upload failed for ${doc.doc_name}.`);
    }
  });
}
  validateFiles(): boolean {
    this.submitted = true;
    return Object.values(this.uploadedFiles).every(file => file !== null);
  }


  resetUploadForm(): void {
    this.uploadedFiles = {
      'file-upload-1': null,
      'file-upload-2': null,
      'file-upload-3': null,
      'file-upload-4': null,
    };
    for (let i = 1; i <= 4; i++) {
      const inputElement = document.getElementById(`file-upload-${i}`) as HTMLInputElement;
      if (inputElement) {
        inputElement.value = ''; 
      }
    }
    this.submitted = false;
    this.uploadProgress = 0; 
  }


}



